function ScheduleConfiguration() {
    "use strict";
    this.HasAddress = false;
    this.Addresses = [];

    this.HasBluBox = false;
    this.BluBoxes = [];

    this.HasBluHome = false;
    this.BluHomes = [];

    this.HasZone = false;
    this.Zones = [];
}
if (typeof exports !== 'undefined') {
    module.exports = ScheduleConfiguration;
}